import "./TextField.css"
import { TextField as MUITextField, StandardTextFieldProps as MUITextFieldProps} from "@mui/material";

interface TextFieldProps extends MUITextFieldProps {};

function TextField(props: TextFieldProps) {
    return <MUITextField className="textfield" {...props} />
};

export default TextField;